import { Component } from 'react';
import FormTextField from './Fields/FormTextField';
import FormDatePicker from './Fields/FormDatePicker';
import FormSelectField from './Fields/FormSelectField';
import FormMatrixField from './Fields/FormMatrixField';
import FormCheckBox from './Fields/FormCheckBox';
import { connect } from 'react-redux';
import { throwErrorMessage } from '../../lib/error_helper';
import FormRatingScalesField from './Fields/FormRatingScaleField';
import { Typography } from '@mui/material';
import FormTableField from './Fields/FormTableField';
import FormTextWithSuggestionsField from './Fields/FormTextWithSuggestionsField';
import FormImageField from './Fields/FormImageField';

const FIELDS_CODE_WITH_SUB = [
    "matrix_of_choices_only_multi_ans",
    "matrix_of_choices_only_one_ans",
    "table"
];

class FormField extends Component {

    getFields(properties) {

        let fields = [{
            code: "selection",//Booléen
            element: (<FormCheckBox {...properties} />),
            properties,
        }, {
            code: "single_textbox",//Texte
            suggestion: false,
            element: (<FormTextField {...properties} subField={this.props.subField} />),
            properties,
        }, {
            code: "single_textbox",//Texte
            suggestion: true,
            element: (<FormTextWithSuggestionsField {...properties} subField={this.props.subField} />),
            properties,
        }, {
            code: "char", // Caractère - TODO A revoir si vraiment utile
            suggestion: false,
            element: (<FormTextField {...properties} subField={this.props.subField} />),
            properties,
        }, {
            code: "integer",
            suggestion: false,
            element: (<FormTextField {...properties} type={"number"} subField={this.props.subField}/>),
            properties,
        }];

        if (this.props.subField)
            return fields;

        return fields.concat([
            {
                code: "date",//DatePicker
                element: (<FormDatePicker {...properties} />),
                properties,
            },
            {
                code: "date_and_time",//DatePicker
                element: (<FormDatePicker {...properties} />),
                properties,
            },
            {
                code: "multiple_textboxes",
                element: (<FormTextField {...properties} multiline />),
                properties,
            },
            {
                code: "comment",
                suggestion: true,
                element: (<FormTextWithSuggestionsField {...properties} multiline />),
                properties,
            },
            {
                code: "comment",
                suggestion: false,
                element: (<FormTextField {...properties} multiline />),
                properties,
            },
            {
                code: "multiple_choice_multiple_ans",
                element: (<FormSelectField {...properties} multiple />),
                properties,
            },
            {
                code: "multiple_choice_only_one_ans",
                element: (<FormSelectField {...properties} />),
                properties,
            },
            {
                code: "matrix_of_choices_only_multi_ans",
                element: (<FormMatrixField {...properties} multiple />),
                properties,
            },
            {
                code: "matrix_of_choices_only_one_ans",
                element: (<FormMatrixField {...properties} />),
                properties,
            },
            {
                code: "rating_scale",
                element: (<FormRatingScalesField {...properties} />),
                properties,
            },
            {
                code: "multiple_textboxes_diff_type",//Texte?
                element: (<FormTextField {...properties} multiline />),
                properties,
            },
            {
                code: "numerical_textboxes",//Texte
                element: (<FormTextField {...properties} type={"number"} />),
                properties,
            },
            {
                code: "descriptive_text",//Texte
                element: (
                    <Typography >{properties.metaQuestion.descriptive_text}</Typography>
                ),
                properties,
            },
            {
                code: "table",
                element: (<FormTableField {...properties} />),
                properties,
            },
            {
                code: "descriptive_image",
                element: (<FormImageField {...properties} />),
                properties,
            },
        ]);
    }

    getField() {
        if (!this.props.question) {
            this.props.throwErrorMessage({
                title: "Attention",
                message: "La réponse [" + this.props.metaQuestion.type + "] " + this.props.metaQuestion.question + " est introuvable. " +
                    "La question a sûrement été ajoutée après l'initialisation du sondage"
            });

            return null;
        }

        let commonProperties = {
            inputProperties: {
                id: this.props.id,
                required: this.props.metaQuestion.is_require_answer,
                disabled: this.props.disabled || this.props.metaQuestion.readonly,
                className: this.props.visible ? "" : "hidden",
                visible: FIELDS_CODE_WITH_SUB.find((f) => f === this.props.metaQuestion.type) ? this.props.visible : undefined,
                centerfield: this.props.centerfield,
                singlechoice: this.props.singlechoice
            },
            responseValueChange: this.props.responseValueChange,
            question: this.props.question,
            metaQuestion: this.props.metaQuestion,
            answers: this.props.metaQuestion.answer_choice_ids,   
            save: this.props.save         
        }

        let field = this.getFields(commonProperties).find((f) => f.code === this.props.metaQuestion.type && (this.props.metaQuestion.dynamic_list ? f.suggestion === this.props.metaQuestion.dynamic_list : !f.suggestion));

        if (!field) {
            this.props.throwErrorMessage({
                title: "Attention",
                message: "Un composant est introuvable. Contactez le support applicatif afin" +
                    " de vérifier la configuration pour la question [" + this.props.metaQuestion.type + "] " + this.props.metaQuestion.question,
            });

            return null;
        }

        return field;
    }

    getComment() {
        if (this.props.metaQuestion.is_comment_require) {
            let properties = {
                inputProperties: {
                    id: this.props.id,
                    required: this.props.metaQuestion.is_require_answer,
                    disabled: this.props.disabled || this.props.metaQuestion.readonly,
                    className: this.props.visible ? "" : "hidden",
                    visible: FIELDS_CODE_WITH_SUB.find((f) => f === this.props.metaQuestion.type) ? this.props.visible : undefined,
                    centerfield: this.props.centerfield,
                    singlechoice: this.props.singlechoice
                },
                responseValueChange: this.props.responseValueChange,
                question: this.props.question,
                metaQuestion: this.props.metaQuestion,
                answers: this.props.metaQuestion.answer_choice_ids,            
            }
            return <FormTextField {...properties} isComment multiline={this.props.metaQuestion.comment_field_type === 'text'} />;
        }

        return null;
    }

    throwErrorMessage(objError) {
        if (!this.state.errorMessageTimeout)
            this.setState({
                errorMessageTimeout: setTimeout(() => {
                    this.props.throwErrorMessage(objError);
                }, this.state.timeout)
            });
    }

    render() {
        let field = this.getField();
        let comment = this.getComment();

        if (!field || !field.properties) {
            return null;
        }        

        return (
            <div>
                {field.element}
                {comment ? 
                    <div style={{marginTop: '5px'}}>
                        <Typography variant="h6">{this.props.metaQuestion.comment_label}</Typography>
                        {comment} 
                    </div>
                : null}            
            </div>
        );
    }
}

const mapStateToProps = () => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        throwErrorMessage: (errorObject) => dispatch(throwErrorMessage(errorObject)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FormField);
